/* eslint-disable prefer-destructuring */
export default function deviceInfoGenerator() {
  let os;
  let device;
  const { userAgent } = window.navigator;
  const userAgentArray = userAgent.split('(');
  const userAgentInfo = userAgentArray[1].split(')');
  const deviceInfo = userAgentInfo[0].split(';');
  if (deviceInfo.length === 3) {
    if (deviceInfo[1].indexOf('Android') !== -1) {
      os = deviceInfo[1];
      device = deviceInfo[2];
    } else {
      os = 'Undefined';
      device = 'Undefined';
    }
  } else if (deviceInfo.length === 2) {
    if (deviceInfo[0].indexOf('iPhone') !== -1 || deviceInfo[0].indexOf('Mac') !== -1) {
      os = deviceInfo[0];
      device = deviceInfo[1];
    } else if (deviceInfo[1].indexOf('Linux') !== -1) {
      os = deviceInfo[1];
      device = 'Desktop';
    }
  } else {
    os = 'Undefined';
    device = 'Undefined';
  }
  return [os, device];
}
